import { useState, useEffect } from "react";
import { initializeApp } from "firebase/app";
import { isSupported, getMessaging, getToken, onMessage } from "firebase/messaging";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKED,
  messagingSenderId: process.env.REACT_APP_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
}

export const useFirebase = (onFirebaseMessage = () => { }) => {
  const [app] = useState(initializeApp(firebaseConfig));
  const [messaging, setMessaging] = useState();
  const [firebaseToken, setFirebaseToken] = useState();

  useEffect(() => {
    isSupported().then((supported) => {
      if (supported) {
        setMessaging(getMessaging(app));
      }
    });
  }, [setMessaging, app]);

  const notificationHandler = function (permission) {
    console.log("Notification permission: ", permission, messaging);
    if (permission === "granted" && messaging) {
      getToken(messaging, {
        vapidKey: process.env.REACT_APP_VAPID_KEY,
      })
        .then((token) => {
          setFirebaseToken(token);
        })
        .catch((err) => {
          console.error("Firebase Error: ", err);
        });
    }
  }

  useEffect(() => {
    if ('Notification' in window) {
      try {
        Notification.requestPermission().then((permission) => notificationHandler(permission));
      } catch (error) {
        // Safari doesn't return a promise for requestPermissions and it                                                                                                                                       
        // throws a TypeError. It takes a callback as the first argument                                                                                                                                       
        // instead.
        if (error instanceof TypeError) {
          Notification.requestPermission((permission) => notificationHandler(permission));
        } else {
          console.log(error)
        }
      }     
      
    } else {

    }
  }, [messaging]);

  useEffect(() => {
    if (messaging) {
      const unsubscribe = onMessage(messaging, onFirebaseMessage);
      return () => unsubscribe();
    }
  }, [messaging, onFirebaseMessage]);

  return { firebaseToken };
}
